// extracted by mini-css-extract-plugin
export default {"container":"ContentTitle_container__0hdhF","title":"ContentTitle_title__wMq8z"};